export const transformImportedName = (
  name: string | undefined | null
): string => {
  const alphanumericString = name?.match(/[a-zA-Zа-яА-Я0-9]+/g);
  const firstThreeSubstrings =
    alphanumericString && alphanumericString.slice(0, 3);
  const resultString = firstThreeSubstrings
    ? firstThreeSubstrings.join(' ')
    : '';
  return resultString;
};
